export default "__VITE_ASSET__C5I8ie2P__"